import { type PayoutBatchItem, PayoutBatchDestinationCheckStatus } from "../types/payoutBatches.types";
import { batchDestinationBeneficiary } from "./batchDestination";

export interface BatchBeneficiary {
  /** The name to lead with: the one the file gave, else the holder the directory reported. */
  name: string | null;
  fromDirectory: boolean;
  /** The directory's holder, shown under a name the file gave. */
  directoryHolder: string | null;
}

export function batchBeneficiary(
  item: Pick<PayoutBatchItem, "beneficiary_name" | "destination" | "destination_check">,
): BatchBeneficiary {
  const typed = item.beneficiary_name?.trim() || batchDestinationBeneficiary(item.destination);
  const check = item.destination_check;
  const holder =
    check?.status === PayoutBatchDestinationCheckStatus.FOUND ? check.holder_name?.trim() || null : null;
  if (typed) {
    return { name: typed, fromDirectory: false, directoryHolder: holder === typed ? null : holder };
  }
  return { name: holder, fromDirectory: holder !== null, directoryHolder: null };
}
